import { useField } from "formik";
import { useState, forwardRef } from "react";

const CustomPasswordInput = forwardRef(
  (
    { label, className = "", layout = "stacked", labelWidth = {}, labelClassName = "", ...props },
    ref,
  ) => {
    const [field, meta] = useField(props);
    const [showPassword, setShowPassword] = useState(false);

    const inputClassName = `custom-primary-input ${className} ${meta.touched && meta.error ? "custom-input-error" : ""
      }`.trim();

    const getLabelWidths = () => ({
      "--label-width-mobile": labelWidth?.mobile || "100px",
      "--label-width-tablet": labelWidth?.tablet || "100px",
      "--label-width-desktop": labelWidth?.desktop || "100px",
    });

    return (
      <div
        className={`custom-input-group ${layout === "inline" ? "inline-layout" : ""
          }`}
        style={layout === "inline" ? getLabelWidths() : {}}
      >
        <div className="label-container">
          <label className={labelClassName}>{label}</label>
        </div>

        <div style={{ flex: layout === "inline" ? 1 : "unset" }}>
          <div className="password-wrapper">
            <input
              {...field}
              {...props}
              type={showPassword ? "text" : "password"}
              className={inputClassName}
              ref={ref}
            />

            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <i className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"}`} />
            </span>
          </div>

          {meta.touched && meta.error && (
            <div className="custom-error">{meta.error}</div>
          )}
        </div>
      </div>
    );
  },
);

export default CustomPasswordInput;
